import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,        // 30s — data considered fresh
      gcTime: 5 * 60 * 1000,       // 5min — cache kept in memory
      refetchOnWindowFocus: false,  // avoid noise on alt-tab
      retry: 1,
    },
  },
});

export { queryClient, QueryClientProvider };
